// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
        suggestionMobileStyle: 'style2',
        suggestionStyle: 'style1',
	}
};

(function() {
    BoostPFS.inject(this);
    
    //felippe boost 153817
    var isSpecialCustomer = false
    
    var showGeorgeTest = true
    var showTasteOfOlive = true
    var showNonGeorgeTest1 = true
    var showNonGeorgeTest2 = true
    
    var customerTags = boostPFSConfig.customer.tags
    
    if (customerTags?.includes('Active')) {
      isSpecialCustomer = true
    }
    if (customerTags?.includes('tasteofolive')) {
      showTasteOfOlive = false
    }
    if (customerTags?.includes('georgetest')) {
      showGeorgeTest = false
    }
    if (customerTags?.includes('georgetest1')) {
      showNonGeorgeTest1 = false
    }
    if (customerTags?.includes('georgetest2')) {
      showNonGeorgeTest2 = false
    }
    
    
    
    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
      var suggestionElement = this.$uiMenuElement;
      var searchElement = this.$element;
      var searchBoxId = this.id;
    };
    
    
    /* start-boost-custom */
    /* #boost-91479: Show metafield information */
    InstantSearchResultItemProduct.prototype.afterRender = function() {
      if (!this.isShow) return;
    
      var flavor = Utils.getProductMetafield(this.data, 'product-info', 'product_flavors');
      if (!flavor) return;
    
      var $title = this.$element.find('.boost-pfs-search-suggestion-product-title')
    
      var html = '<p class="boost-pfs-search-suggestion-product-flavor">' + flavor + '</p>';
      jQ(html).insertAfter($title);
    }
    
    //boost felippe 153817
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
      this.prepareSuggestionProductPriceData();
    
      if(!boostPFSConfig.customer.isLogged){
        return `<p style="font-size:12px;"><a class="createAccountLink" href="/account/login">Log in</a> to view price or <a href="/pages/register">request an account.<a/></p>`;
      }
      
      if(!isSpecialCustomer){
        return `<p style="font-size:12px;">Your account is temporarily on hold because of inactivity. Please <a href="/pages/contact">contact us</a> to reinstate it.</p>`;
      }
      
    console.log(this.data)
      // Check on sale
      var onSale = this.data.compare_at_price_min > this.data.price_min;
      // Format price
      var price = Utils.formatMoney(this.data.price_min);
      var compareAtPrice = '';
      if (this.data && this.data.compare_at_price_min) {
        compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
        if (Settings.getSettingValue('search.removePriceDecimal')) {
          price = Utils.removeDecimal(price);
          compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
      }
    
      // Build Price
      var result = '';
      if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
        if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
          result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
        } else {
          result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        }
      }
    
      var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
      if (priceVaries) {
        price = 'From ' + price;
      }
      return result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice);
    }
    
    //felippe boost 153817
    InstantSearchApi.beforeCall = function(searchTerm) {
      console.log( boostPFSConfig.customer)
    
      /* Change the params before calling api */
      if (!showTasteOfOlive) {
        Globals.instantSearchQueryParams.h_options = 'tasteofolive';
      }
    
      if (!showGeorgeTest) {
        Globals.instantSearchQueryParams.h_options = 'georgetest';
      }
    
      if (!showNonGeorgeTest1) {
        Globals.instantSearchQueryParams.h_options = 'non-georgetest1';
      }
      if (!showNonGeorgeTest2) {
        Globals.instantSearchQueryParams.h_options = 'non-georgetest2';
      }

      console.log('h_options:', Globals.instantSearchQueryParams.h_options)
                      
    };
    /* end-boost-custom */
})();